import React from 'react'
import {Route} from 'react-router-dom'
import {connect} from 'react-redux'
import {withRouter} from 'react-router'
import axios from 'axios'
import Cookies from 'universal-cookie'

import {userLogout} from '../action/user'
import {COOKIE_TOKEN} from '../app/constant'
import {URL_LOGIN} from '../const'

@connect(
    (state) => {
        if (state.user.loginStatus === true) {
            return {
                loginStatus: true,
                token: state.user.info.token
            }
        }
        return {
            loginStatus: false
        }
    },
    {
        userLogout
    }
)
class PrivateRoute extends React.Component {
    render() {
        const cookies = new Cookies()
        let redirectSuffix = ""
        const pathName = this.props?.location?.pathname || ""
        if (pathName) {
            redirectSuffix = 'redirect='+pathName
        }
        if (this.props.loginStatus === false || cookies.get(COOKIE_TOKEN) !== this.props.token) {
            this.props.userLogout()
            if (this.props.location?.search) {
                this.props.history.push({
                    pathname: URL_LOGIN + this.props.location?.search + "&?" + redirectSuffix
                })
                window.location.reload()
            } else {
                this.props.history.push({
                    pathname: URL_LOGIN + "?" + redirectSuffix
                })
                window.location.reload()
            }
            return null
        }
        axios.defaults.headers.common['Authorization'] = 'Token ' + this.props.token
        return <Route {...this.props} />
    }
}

export default withRouter(PrivateRoute)
